export function getSavedQuoteColorMode() {
  try { return localStorage.getItem('quote-color-mode') === 'green-up' ? 'green-up' : 'red-up' }
  catch (_) { return 'red-up' }
}

export function applyQuoteColorMode(mode) {
  const value = mode === 'green-up' ? 'green-up' : 'red-up'
  document.documentElement.dataset.quoteColors = value
  try { localStorage.setItem('quote-color-mode', value) } catch (_) { /* Still apply when storage is unavailable. */ }
}

export function quoteColors(theme = document.documentElement.dataset.theme, mode = getSavedQuoteColorMode()) {
  const red = theme === 'light' ? '#c92a22' : '#ff4a4a'
  const green = theme === 'light' ? '#16783b' : '#3cc864'
  return { up: mode === 'green-up' ? green : red, down: mode === 'green-up' ? red : green, flat: theme === 'light' ? '#68768a' : '#9da6b3' }
}

export function quoteTone(value) {
  if (value == null || String(value).trim() === '') return ''
  const number = Number(String(value).trim().replace(/%$/, ''))
  if (!Number.isFinite(number)) return ''
  return number > 0 ? 'rise' : number < 0 ? 'fall' : ''
}
